import React from "react";
import { Nav, NavItem, TabContent, TabPane, NavLink } from "reactstrap";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import {
    computedStore,
    designStore,
    generalConfigStore,
    setActiveTabIndex,
    setFinalMessageItems,
    setFooterFinalMessage,
    setFooterTicketNumberMessage,
    setInformationMessageItems,
    setIsBackgroundActive,
    setIsFooterFinalMessageActive,
    setIsFooterTicketNumberMessageActive,
    setIsHeaderActive,
    setIsInformationMessageActive,
    setIsLogoActive,
    setIsTicketNumberActive,
    setIsTopBannerActive,
} from "@store";

import { Model } from "./Model";
import { Design } from "./Design";
import { Transition } from "../Transition";

import "@pages/GeneralConfig/Design/index.css";

import { useSnapshot } from "valtio";

export function FinalMessageContent(): JSX.Element {
    const { t } = useTranslation();
    const { elements } = useSnapshot(computedStore);
    const { activeSlideIndex } = useSnapshot(designStore);
    const {
        project: { template },
    } = useSnapshot(generalConfigStore);
    const tabs: TabsType[] = [
        {
            title: t("Model"),
            content: <Model />,
            customClassName: "cgt_txt_model",
        },
        {
            title: t("Design"),
            content: <Design />,
            customClassName: "cgt_txt_design",
        },
        {
            title: t("Transition"),
            content: <Transition />,
            customClassName: "cgt_txt_transition",
        },
    ];

    const [activeTab, setActiveTab] = React.useState<number>(0);

    function toggleNav(tab: number) {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    }

    React.useEffect(() => {
        setActiveTabIndex(activeTab === 1 ? 0 : -1);
    }, [activeTab]);

    React.useEffect(() => {
        if (elements.length > 0 && elements[activeSlideIndex] !== undefined) {
            setFooterTicketNumberMessage(
                (((template.pages.ways["finalMessage"] as PageType)
                    .footer as FooterType)
                    .ticketNumberMessage as InformationMessageType).languages
            );

            setFooterFinalMessage(
                (((template.pages.ways["finalMessage"] as PageType)
                    .footer as FooterType)
                    .finalMessage as InformationMessageType).languages
            );

            setIsFooterTicketNumberMessageActive(
                ((template.pages.ways["finalMessage"] as PageType)
                    .footer as FooterType).ticketNumberMessage.active
            );

            setIsFooterFinalMessageActive(
                ((template.pages.ways["finalMessage"] as PageType)
                    .footer as FooterType).finalMessage.active
            );

            setFinalMessageItems(
                (template.content.finalMessage as FinalMessageContentType).items
            );
            setIsInformationMessageActive(
                (template.pages.ways["finalMessage"] as PageType).header
                    .informationMessage.active
            );

            setInformationMessageItems(
                (template.pages.ways["finalMessage"] as PageType).header
                    .informationMessage.languages
            );
            setIsTopBannerActive(
                (template.pages.ways["finalMessage"] as PageType).topBanner
                    .active
            );
            setIsHeaderActive(
                (template.pages.ways["finalMessage"] as PageType).header.active
            );

            setIsLogoActive(
                (template.pages.ways["finalMessage"] as PageType).topBanner.logo
                    .active
            );
            setIsBackgroundActive(
                // eslint-disable-next-line
                (template.pages.ways["finalMessage"] as PageType)!.background
                    .active
            );
            setIsTicketNumberActive(
                ((template.pages.ways["finalMessage"] as PageType)
                    .footer as FooterType).isTicketNumberActive
            );
        }
    }, [activeSlideIndex, elements, template]);

    return (
        <div style={{ height: "634px" }}>
            <div className="cursor__clz pl-3 py-2" style={{ fontSize: "22px" }}>
                {t("Step: Final message")}
            </div>

            <div className="mb-2" style={{ height: "100%" }}>
                <div style={{ width: "576px" }}>
                    <Nav tabs className="bg-white">
                        {tabs.map((element, index) => {
                            return (
                                <NavItem
                                    key={index}
                                    className={classNames(
                                        "border",
                                        {
                                            "advanced-nav-item-active__clz":
                                                activeTab === index,
                                        },
                                        element.customClassName
                                    )}
                                >
                                    <NavLink
                                        className={classNames(
                                            "border-0 sales-methods-nav-link__clz",
                                            {
                                                "active nav-tabs-active-link__clz":
                                                    activeTab === index,
                                            }
                                        )}
                                        onClick={() => {
                                            toggleNav(index);
                                        }}
                                    >
                                        <span className="px-2">
                                            {element.title}
                                        </span>
                                    </NavLink>
                                </NavItem>
                            );
                        })}
                    </Nav>
                </div>
                <TabContent
                    activeTab={activeTab}
                    style={{
                        width: "100%",
                        height: "93%",
                    }}
                    className="bg-white border-0 rounded"
                >
                    {tabs.map((element, index) => {
                        return (
                            <TabPane
                                tabId={index}
                                style={{ height: "100%", width: "100%" }}
                                key={index}
                            >
                                {element.content}
                            </TabPane>
                        );
                    })}
                </TabContent>
            </div>
        </div>
    );
}
